import { create } from "zustand";
interface SuspensionType {
    able: boolean;
    time: number;
}

interface Action {
    setSuspensionData: (value: SuspensionType) => void;
}

const initialState: Partial<SuspensionType> = {};
/**
 * @description vip
 */
export const useSuspensionStore = create<Partial<SuspensionType> & Action>()((set, get) => {
    return {
        ...initialState,
        setSuspensionData: (values) => set((state) => ({ ...state, ...values })),
        // reset: () => set(initialState),
    };
});
